import React, { useEffect, useState } from "react";
import "./Refunds.scss";
import {
  Button,
  Col,
  Divider,
  Form,
  Row,
  Space,
  Table,
  Typography,
  notification,
} from "antd";
import { dataInputRefunds } from "./RefundsDataInput";
import { InputFields } from "components/common";
import { columnsRefunds } from "./Refunds.config";
import TableInputAdd from "components/common/TableInputAdd/TableInputAdd";
import Icon from "assets/icons";
import { payService } from "api";
import { PrinterSVG } from "assets";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import ModalAddRefunds from "./ModalAddRefunds/ModalAddRefunds";
import { setCallApi, setDataRefunds } from "redux/reducer/reduxCommon";
import Notification from "components/common/notification/notification";
import ModalPrint from "./ModalPrint/ModalPrint";

const Refunds = () => {
  const [data, setData] = useState([]);
  const [loadingTable, setLoadingTable] = useState(true);
  const [totalPage, setTotalPage] = useState();
  const [limit, setLimit] = useState(50);
  const [currentPage, setCurrentPage] = useState(1);
  const idData = useAppSelector((state) => state.reduxCommon.id);
  const [form] = Form.useForm();
  // console.log("id data hoan phi", idData);
  const [isShowModal, setIsShowModal] = useState(false);
  const [dataRefunds, setDataRefund] = useState([]);
  const disPath = useAppDispatch();
  const [isShowModalPrint, setIsShowModalPrint] = useState(false);
  const callApi = useAppSelector((state) => state.reduxCommon.callApi);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [listId, setListId] = useState<any>();

  // const tachPhanTu = (dataInput) => {
  //   const newData = [];
  //   dataInput.forEach(item => {
  //       if (item.soLuong > 1) {
  //           for (let i = 0; i < item.soLuong; i++) {
  //               const newItem = { ...item, soLuong: 1 };
  //               newData.push(newItem);
  //           }
  //       } else {
  //           newData.push(item);
  //       }
  //   });
  //   return newData;
  // }

  useEffect(() => {
    try {
      const response = payService
        .getListRefundsById(idData, currentPage, limit)
        .then((res) => {
          // console.log("res hoan phi", res.data);
          // notification.success({ message: "Lấy dữ liệu thành công" });
          const newData = res.data.data.map((item) => ({
            key: item.id,
            noiDung: item.noiDung,
            bh: item.idTinhTrangBaoHiem,
            donGiaBV: item.donGiaBenhVien,
            donGiaBH: item.donGiaBaoHiem,
            soLuong: item.soLuong,
            thanhTien: item.thanhTien,
            ngayChiDinh: item.ngayChiDinh,
            thoiGianThanhToan: item.thoiGianThanhToan,
            nguoiThanhToan: item.nguoiThanhToan,
            trangThai: item.idTrangThaiHoanPhi,
            nguoiDeNghi: item.nguoiDeNghi,
            lyDoHoan: item.lyDoHoan,
            thoiGianHoan: item.thoiGianHoan,
            nguoiDuyetHoan: item.nguoiDuyetHoan,
            idHinhThucHoanPhi: item.idHinhThucHoanPhi,
          }));
          // const newDataTable = tachPhanTu(newData);
          setData(newData);
          setLoadingTable(false);
          setTotalPage(res.data.total);
        });
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi lấy dữ liệu hoàn phí");
    }
  }, [currentPage, idData, callApi, limit]);

  const handlePaginationChange = (page, pageSize) => {
    setCurrentPage(page);
    setLimit(pageSize);
  };

  const paginationConfig = {
    current: currentPage,
    total: totalPage,
    pageSize: limit,
    onChange: handlePaginationChange,
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKeys(selectedRowKeys);
      // console.log(
      //   `selectedRowKeys:`, selectedRowKeys,
      //   "selectedRows: ",
      //   selectedRows
      // );
      setDataRefund(selectedRows);
      const filteredData = selectedRows.filter((item) => {
        return item.trangThai === 1;
      });

      const keysOfFilteredData = filteredData.map((item) => {
        return item.key;
      });
      setListId(keysOfFilteredData);
    },
    getCheckboxProps: (record: any) => ({
      name: record.name,
    }),
  };

  const handleOk = () => {
    setIsShowModal(false);
  };

  const handleCancel = () => {
    setIsShowModal(false);
  };

  const handleOnShowModal = async () => {
    const newData = await dataRefunds.filter((row) => row.trangThai == 0);
    // console.log('sadsadsadas', newData);
    if (!newData || !newData.length) {
      Notification("warning", "Vui lòng chọn dịch vụ đã thanh toán");
      return;
    } else {
      const arrayId = newData.map((item) => item.key);
      // console.log('arrayId', arrayId);
      await disPath(setDataRefunds(arrayId));
      setIsShowModal(true);
      setDataRefund([]);
      setSelectedRowKeys([]);
      disPath(setCallApi());
    }
  };

  useEffect(() => {
    setSelectedRowKeys([]);
    setListId([]);
  }, [idData]);

  // const handleOnSubmitRefunds = async () => {
  //   const newData = await dataRefunds.filter((row) => row.trangThai == 1);
  //   // console.log('sadsadsadas', newData);
  //   if(!newData || !newData.length){
  //     return;
  //   }
  //   else {
  //     const arrayId = newData.map((item) =>
  //     item.key,
  //     );
  //     const dataID = {
  //       list_id: arrayId
  //     }
  //     // console.log('arrayId', dataID);
  //     await submitRefunds(dataID);
  //     setDataRefund([]);
  //     setSelectedRowKeys([]);
  //     disPath(setCallApi());
  //   }
  // }

  const handleOnCancelSubmitRefunds = async () => {
    const newData = await dataRefunds.filter((row) => row.trangThai == 1);
    if (!newData || !newData.length) {
      Notification("warning", "Vui lòng chọn dịch vụ đã hoàn phí");
      return;
    } else {
      const arrayId = newData.map((item) => item.key);
      const dataCancel = {
        list_id: arrayId,
      };
      // console.log('data huỷ', dataCancel);
      try {
        const response = await payService
          .cancelRefunds(dataCancel)
          .then((res) => {
            Notification("success", "Đã huỷ hoàn phí thành công");
            setDataRefund([]);
            setSelectedRowKeys([]);
            disPath(setCallApi());
          });
      } catch (error) {
        Notification("error", "Đã có lỗi xảy ra khi huỷ hoàn phí");
      }
    }
  };

  const submitRefunds = async (data) => {
    try {
      const response = payService.submitRefundsById(data).then((res) => {
        // notification.success({ message: "Lấy dữ liệu thành công" });
      });
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi duyệt");
    }
  };

  const handleOnPrint = () => {
    if (!listId || !listId.length) {
      Notification("warning", "Vui lòng chọn phiếu đã hoàn phí cần in");
      return;
    }
    setIsShowModalPrint(true);
  };

  const handleOpen = () => {
    setIsShowModalPrint(false);
  };

  const handleCancelPrint = () => {
    setIsShowModalPrint(false);
  };

  return (
    <div className="refunds-tab-container">
      <Space direction="vertical" size={"middle"} style={{ width: "100%" }}>
        <Row justify={"end"} gutter={[16, 8]}>
          <Col>
            <Button
              type="text"
              className="btn-sub"
              icon={<Icon.printer />}
              onClick={handleOnPrint}
            >
              In phiếu hoàn
            </Button>
          </Col>
          <Col>
            <Button
              type="primary"
              style={{ backgroundColor: "#00A8B3" }}
              onClick={handleOnShowModal}
            >
              Đề nghị hoàn
            </Button>
          </Col>
          {/* <Col>
            <Button 
              type="primary"
              onClick={handleOnSubmitRefunds}
            >Duyệt hoàn</Button>
          </Col> */}
          <Col>
            <Button danger type="primary" onClick={handleOnCancelSubmitRefunds}>
              Huỷ duyệt
            </Button>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form>
              <Table
                bordered
                dataSource={data}
                columns={columnsRefunds}
                pagination={paginationConfig}
                loading={loadingTable}
                scroll={{ x: 1500 }}
                rowSelection={{
                  ...rowSelection,
                }}
              />
            </Form>
          </Col>
        </Row>
      </Space>
      <ModalAddRefunds
        isShowModal={isShowModal}
        handleOk={handleOk}
        handleCancel={handleCancel}
      />
      <ModalPrint
        isShowModal={isShowModalPrint}
        handleOk={handleOpen}
        handleCancel={handleCancelPrint}
        listId={listId}
      />
    </div>
  );
};

export default Refunds;
